import { connect } from "react-redux";
import { saveBackgroundImageUrl } from "../../actions/layoutActions";
import Settings from "./settings";
import type { AppDispatch, RootState } from "../../store";

const mapStateToProps = (state: RootState) => {
  const { backgroundUrl } = state.layouts;
  return {
    backgroundUrl
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    onBackgroundImageBlur: (backgroundImageUrl: string) => {
      dispatch(saveBackgroundImageUrl(backgroundImageUrl));
    }
  };
};

const SettingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);

export default SettingsContainer;
